import React from "react";

// Web shim for react-native-render-html (v4 API; the native build is otherwise
// noop'd, which blanked plan descriptions, incentives, support-ticket bodies and
// ledger text). The app renders TRUSTED backend HTML, so on web we extract the
// markup from either `html` (v4 string prop) or `source.html` and render it
// through a real DOM node. A `source.uri` falls back to an <iframe>.
// Native is untouched (the real renderer loads there).

const RenderHtml = ({ html, source, baseStyle }) => {
  let markup = "";
  if (typeof html === "string") markup = html;
  else if (source && typeof source.html === "string") markup = source.html;
  else if (source && typeof source.uri === "string") {
    return React.createElement("iframe", {
      src: source.uri,
      style: { border: "0", width: "100%" },
    });
  }

  return React.createElement("div", {
    dangerouslySetInnerHTML: { __html: markup },
    style: { width: "100%", overflowWrap: "anywhere", ...(baseStyle || {}) },
  });
};

export default RenderHtml;
export { RenderHtml };
